import { Button } from "~/components/ui/button";
import { claimCtaClassName } from "~/hec/components/molecules/claim-card/claim-cta-class";
import { handleDocumentNavClick } from "~/hec/components/ui/document-nav-guard";
import { cn } from "~/lib/ui";

import type { EnrollCtaProps } from "./types";

/**
 * Molecule: a button-shaped link to the Perks enrollment page, shown in place
 * of Claim when the shopper is signed in but not a member (COM-506 review).
 *
 * `/loyalty-perks` is SFRA-proxied (`legacy-routes.ts`) and the same path on
 * FSA and HSA, so this is a raw anchor into a full-document navigation and
 * carries the COM-67 re-entrant click guard itself — the same treatment the
 * goal banner gives this exact URL. Its sibling `SignInCta` needs no guard:
 * `#login` only opens a drawer.
 */
export function EnrollCta({
  label,
  variant = "cta",
  className,
  ...rest
}: EnrollCtaProps) {
  return (
    <Button
      asChild
      variant={variant}
      size="fit"
      className={cn(claimCtaClassName, className)}
    >
      <a href="/loyalty-perks" onClick={handleDocumentNavClick} {...rest}>
        {label}
      </a>
    </Button>
  );
}
